import React from "react";
import * as MuiIcons from "@mui/icons-material";
import { industries } from "../../data/companyData";
import "./SaasSections.css";

function getIcon(name) {
  const Icon = MuiIcons[name] || MuiIcons.Business;
  return <Icon fontSize="large" />;
}

export default function IndustriesSection() {
  return (
    <section className="saas-section industries-section" id="industries-section">
      <h2 className="saas-section__title">INDUSTRIES WE SERVE</h2>
      <div className="saas-section__header">
        <p className="saas-section__intro">
          Purpose-built SaaS platforms for high-growth sectors across India and beyond.
        </p>
      </div>
      <div className="industries-grid">
        {industries.map((industry) => (
          <div key={industry.name} className="industry-card">
            <div className="industry-card__icon">{getIcon(industry.icon)}</div>
            <h3 className="industry-card__name">{industry.name}</h3>
            <p className="industry-card__desc">{industry.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
